import React from "react";
import { IFeaturedOffersProps } from "./FeaturedOffersProps";
import { StyledContainer } from "./FeaturedOffersHelpers";
import { Link, Slice } from "gatsby";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SubTitle from "../../global/SubTitle/SubTitle";
import TemplateOffersList from "../../common/Offers/TemplateOffersList/TemplateOffersList";

const FeaturedOffers: React.FC<IFeaturedOffersProps> = (props) => {
  const offers = props.node.relationships.offers;
  const offerParentType = props.node.parent_type;
  const hotel =
    offerParentType == "hotel" && props.node.relationships.hotel
      ? props.node.relationships.hotel
      : null;
  const hotelPath = hotel && hotel.length ? hotel[0].path.alias : null;
  return (
    <StyledContainer>
      <Row id="mainContent">
        <Col className="text-center">
          <SubTitle id="featured-offer-subtitle">
            {props.node.field_subtitle}
          </SubTitle>
          <h3 id="featured-offer-title">{props.node.field_title}</h3>
          {props.node.field_description && (
            <p
              className="featured-offer-description"
              dangerouslySetInnerHTML={{ __html: props.node.field_description }}
            />
          )}
          {props.node.field_link && (
            <Link
              id="featured-offers-link"
              to={props.node.field_link.url}
              className={`teaser-link ${props.color ? "text-white" : ""}`}
            >
              {props.node.field_link.title}
            </Link>
          )}
        </Col>
      </Row>

      <TemplateOffersList
        offers={offers}
        location={props.location}
        crsCode={props.crsCode}
        hotelPath={hotelPath}
      />
    </StyledContainer>
  );
};

export default FeaturedOffers;
